import "../tablas/paginacion.css"

export default function Paginacion({
  paginaActual,
  totalPaginas,
  onCambiarPagina
}) {
  return (
    <div className="tabla-paginacion">

      <button
        onClick={() => onCambiarPagina(paginaActual - 1)}
        disabled={paginaActual === 1}
      >
        ←
      </button>

      <span>
        {paginaActual} / {totalPaginas}
      </span>

      <button
        onClick={() => onCambiarPagina(paginaActual + 1)}
        disabled={paginaActual === totalPaginas}
      >
        →
      </button>

    </div>
  );
}